import { createContext, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ErrorMessage, Spinner } from "app/components";
import { empresasService } from "app/services";

const EncargadoContext = createContext();

const initialState = {
  encargado_id: 0,
  empresa_id: 0,
  genero_id: 0,
  encargado_nombre_completo: "",
  encargado_identificacion: "",
  encargado_telefono: "",
  encargado_celular: "",
  encargado_correo_electronico: "",
  cargos: [],
};

export function EncargadoProvider({ children }) {
  const params = useParams();

  const [encargado, setEncargado] = useState(initialState);
  const [isEditing, setEditing] = useState(false);

  const encargadoQuery = useQuery({
    queryKey: ["empresa:get:encargado", params.empresa_id, params.encargado_id],
    queryFn: () =>
      empresasService.getEncargado({
        empresaId: params.empresa_id,
        encargadoId: params.encargado_id,
      }),
    onSuccess: (data) => {
      setEncargado(data);

      setEditing(true);
    },
    enabled: !!params.encargado_id,
  });

  if (!!encargadoQuery.isLoading && !!params.encargado_id) {
    return <Spinner label="Cargando el encargado..." />;
  } else if (!!encargadoQuery.isFetching && !!params.encargado_id) {
    return <Spinner label="Recuperando el encargado..." />;
  } else if (!!encargadoQuery.isRefetching && !!params.encargado_id) {
    return <Spinner label="Recargando el encargado..." />;
  } else if (!!encargadoQuery.isError) {
    return <ErrorMessage message={encargadoQuery.error.response.statusText} />;
  }

  return (
    <EncargadoContext.Provider
      value={{
        encargado,
        setEncargado,
        isEditing,
      }}
    >
      {children}
    </EncargadoContext.Provider>
  );
}

export function useEncargadoContext() {
  const encargadoContext = useContext(EncargadoContext);

  if (!encargadoContext) {
    throw new Error(
      "useEncargadoContext should be used inside the EncargadoProvider."
    );
  }

  return encargadoContext;
}
